/// <reference path="Definitions/custom.d.ts" />
/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $ajax from './_ajax'
import * as $help from './help'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $loading from './_loading'
import * as $types from './_types'

var ownerId: number = 0
var pageName: string = null
var pagePrefix: string = null

export function init($pageName, $pagePrefix, $ownerId): void {
    pageName = $pageName
    pagePrefix = $pagePrefix
    ownerId = $ownerId

    //$('.' + pageName + ' .' + pagePrefix + '-fellingrow-row1-icon').click(function () {
    //    showHideFellingRow2($(this))
    //})

    $helpers.scroll.loadOnScroll('.' + pageName + ' .' + pagePrefix + '-loadonscroll')
    $help.tooltips.initializeTooltips($('.' + $pageName))
    $helpers.partialPageInit($('.' + $pageName))

    $('.' + pageName + ' .' + pagePrefix + '-loadasync').each((idx, elem) => {
        console.log('load immediately ' + idx + elem)
        let url = $(elem).attr('data-url')
        $loading.show('Laddar...')
        $(elem).load(url, () => {
            $help.tooltips.initializeTooltips($(elem))
            $loading.hide()
        })
    })

    $('.' + pageName + ' .' + pagePrefix + '-district-icon').click(function () {
        $modal.show(
            '<a href="/Content/Data/Geographic/counties/' +
                $(this).attr('data-county') +
                '.jpg" target="_blank"><img src="/Content/Data/Geographic/counties/' +
                $(this).attr('data-county') +
                '.jpg" style="width:100%" /></a>',
            true,
            true,
            true
        )
    })

    $('.' + pageName + ' .' + pagePrefix + '-transfer-details-link').click(function () {
        $modal.load(
            '/Default/TransferDetailsModal',
            { id: $(this).attr('data-id') },
            true,
            true,
            true
        )
    })

    $('.' + pageName + ' .' + pagePrefix + '-vehicle-icon').click(function () {
        $modal.load(
            '/Vehicle/ListVehiclesForOwner',
            { id: $(this).attr('data-id') },
            true,
            true,
            true
        )
    })

    var debouncedstickynote = _.debounce(function () {
        $('.' + pageName + ' .' + pagePrefix + '-stickynote-status').html('Sparar...')

        $ajax.post({
            loadingText: 'Sparar...',
            url: '/Owner/SaveStickyNote',
            data: {
                ownerId: ownerId,
                note: $('.' + pageName + ' .' + pagePrefix + '-stickynote').val(),
            },
            success: function (res: $types.object.IJsonResult) {
                if (res.Ok) {
                    $('.' + pageName + ' .' + pagePrefix + '-stickynote-status')
                        .html('Sparat!')
                        .fadeOut()
                } else {
                    $('.' + pageName + ' .' + pagePrefix + '-stickynote-status').html(
                        'Misslyckades spara: ' + res.Message
                    )
                }
            },
        })
    }, 500)
    $('.' + pageName + ' .' + pagePrefix + '-stickynote').on('blur', function () {
        $('.' + pageName + ' .' + pagePrefix + '-stickynote-status')
            .show()
            .html('*')
        debouncedstickynote()
    })
    $('.' + pageName + ' .' + pagePrefix + '-stickynote').on('keyup', function () {
        $('.' + pageName + ' .' + pagePrefix + '-stickynote-status')
            .show()
            .html('*')
        debouncedstickynote()
    })
}

//function showHideFellingRow2(icon: JQuery): void {
//    var ownerId: string = icon.attr('data-id')
//    var shown: boolean = icon.attr('data-shown') == 'true'
//
//    if (shown) {
//        icon.addClass('fa-chevron-right')
//        icon.removeClass('fa-chevron-down')
//        $('.' + pageName + ' .' + pagePrefix + '-fellingrow-row2-' + ownerId).addClass('bcfla-hidden')
//    } else {
//        icon.removeClass('fa-chevron-right')
//        icon.addClass('fa-chevron-down')
//        $('.' + pageName + ' .' + pagePrefix + '-fellingrow-row2-' + ownerId).removeClass('bcfla-hidden')
//    }
//
//    icon.attr('data-shown', (!shown).toString())
//}
